/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('DinghyBoard', DinghyBoard);

    DinghyBoard.$inject = ['$resource', 'DateUtils'];

    function DinghyBoard ($resource, DateUtils) {
        var resourceUrl =  'api/board/dinghies/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateDeactivated = DateUtils.convertLocalDateFromServer(data.dateDeactivated);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateDeactivated = DateUtils.convertLocalDateToServer(copy.dateDeactivated);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateDeactivated = DateUtils.convertLocalDateToServer(copy.dateDeactivated);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

